<template>
            <div>
                <label :for="name" 
                    :class="{ 'tw:block tw:text-sm tw:font-medium tw:text-zinc-800': tw}">
                    {{ label }}
                </label>
                <input :name="name" :type="type" :placeholder="placeholder" :maxlength="maxlength"
                    :id="name"
                       :class="{
                           'tw:mt-1 tw:block tw:w-full tw:rounded-lg tw:border tw:border-zinc-300 tw:bg-white tw:px-3 tw:py-2 tw:text-base tw:text-zinc-800 tw:focus:outline-none tw:focus:ring-1 tw:focus:ring-(--shop-primary) tw:focus:border-(--shop-primary)': tw,
                           'tw:bg-zinc-100 tw:cursor-not-allowed': tw && disabled,
                           'form-control': !tw,
                       }"
                       :disabled="disabled"
                       :required="required"
                       v-model="model" />
                <p :class="{'tw:mt-1 tw:text-sm tw:text-red-600': tw, 'text-danger': !tw}" v-if="error">{{ error }}</p>
            </div>
</template>

<script setup>
defineProps({
    tw: {type: Boolean, default: false},
    label: {type: String, required: true},
    name: {type: String, required: true},
    type: {type: String, default: 'text'},
    placeholder: {type: String, default: ''},
    maxlength: {type: [String, Number], default: null},
    disabled: {type: [String, Boolean], default: false},
    error: {type: String, default: ''},
    required: {type: Boolean, default: false},
})

const model = defineModel()
</script>